import { Field, Form, FormikProps, useFormikContext } from 'formik';
import { FormValues } from './types';
import { FormikRadioGroupInput } from '@forms/Components/RadioGroup';
import CustomerField from './Customer';
import { FormikCheckboxInput } from '../Forms/Components/CheckInput';
import { FormikDateRangePicker } from '../Forms/Components/DateRangePicker';

import styles from './ReportModal.module.css';

type InvoicedChargesAgingProps = FormikProps<FormValues> & {
	id: string;
};

export default function InvoicedChargesAgingForm({ id }: InvoicedChargesAgingProps) {
	const { values, setFieldValue } = useFormikContext<FormValues>();

	const handleCheckboxChange = (isChecked: boolean) => {
		if (isChecked) {
			void setFieldValue('dateFilter', 'Order Date', true);
		}
		void setFieldValue('allCharges', isChecked, true);
	};

	return (
		<Form
			className={styles['report-form']}
			id={id}
		>
			<div className={styles['flex-row']}>
				<Field
					component={FormikRadioGroupInput}
					name='dateFilter'
					label='Date Filter'
					labelPlacement='top'
					defaultOptionSelected='Delivery Date'
					radioItems={['Delivery Date', 'Order Date']}
					disabled={values.allCharges}
				/>
			</div>
			<div className={styles['flex-row']}>
				<div>
					<Field
						name='reportDateRange'
						component={FormikDateRangePicker}
						label='Date Range'
						className={`${styles['date-range-input']} ${styles['margin-bottom']}`}
					/>
				</div>
			</div>
			<div className={styles['flex-row']}>
				<div>
					<CustomerField
						label='Bill To'
						fieldName='customers'
						multiple
						buttonClassName={styles['customer-dropdown']}
					/>
				</div>
			</div>
			<div className={styles['flex-row']}>
				<Field
					component={FormikRadioGroupInput}
					name='accept'
					label='Report Format'
					labelPlacement='top'
					defaultOptionSelected='HTML'
					radioItems={['HTML', 'Excel']}
				/>
				<Field
					component={FormikCheckboxInput}
					name='allCharges'
					label='All Charges'
					onChangeExtension={handleCheckboxChange}
				/>
			</div>
		</Form>
	);
}
